import api from "./Api";

class NFSeService {
  GetNFSe(payload) {
    return api.get("/v1/NFSe/" + payload).then((response) => {
      return response.data;
    });
  }

  PostNFSe(payload) {
    return api.post("/v1/NFSe", payload).then((response) => {
      return response.data;
    });
  }

  PutNFSe(payload) {
    return api.put("/v1/NFSe", payload).then((response) => {
      return response.data;
    });
  }

  DeleteNFSe(payload) {
    return api.delete("/v1/NFSe/" + payload).then((response) => {
      return response.data;
    });
  }

  GetNFSeOData(payload) {
    return api.get("/OData/NFSe" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new NFSeService();
